import { FolderOpen, PencilRuler } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ViewerControlsHelpDialog } from "@/components/top-bar/ViewerControlsHelpDialog";
import type { PixatwinTopBarActionProps } from "@/sdk";
import { useAuthStore } from "@/stores/authStore";
import { useProjectStore } from "@/stores/projectStore";

export const CoreTopBarActions = ({
  adminEditionActions,
  showViewerControlsHelp,
}: PixatwinTopBarActionProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore((state) => state.user);
  const hasMultipleProjects = useProjectStore(
    (state) => state.projects.length > 1,
  );
  const hasAdminEditionActions = adminEditionActions.length > 0;
  const canAccessAdmin =
    user?.role === "ADMIN" && location.pathname !== "/admin";

  return (
    <>
      {hasMultipleProjects ? (
        <Button
          type="button"
          variant="outline"
          className="h-[42px] cursor-pointer rounded-lg border border-slate-300 bg-[#eaeef1] px-3 text-[#171151] hover:bg-[#dde3e7]"
          onClick={() => navigate("/")}
          aria-label="Changer de projet"
          title="Changer de projet"
        >
          <FolderOpen className="h-4 w-4" aria-hidden="true" />
          <span className="hidden sm:inline">Changer de projet</span>
        </Button>
      ) : null}
      {showViewerControlsHelp ? <ViewerControlsHelpDialog /> : null}
      {hasAdminEditionActions ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              type="button"
              variant="outline"
              className="h-10 gap-2 border-slate-300 bg-white/85 px-3 text-slate-700 shadow-sm hover:bg-white"
              aria-label="Ouvrir le menu Edition"
              title="Edition"
            >
              <PencilRuler className="h-4 w-4" aria-hidden="true" />
              <span>Edition</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-60">
            {adminEditionActions.map((action) => (
              <DropdownMenuItem
                key={action.id}
                onSelect={action.onSelect}
                disabled={action.disabled}
                className={
                  action.isActive
                    ? "bg-accent text-accent-foreground"
                    : undefined
                }
              >
                {action.icon}
                <span>{action.label}</span>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      ) : null}
      {canAccessAdmin ? (
        <Button
          onClick={() => navigate("/admin")}
          className="h-[42px] cursor-pointer rounded-lg border border-slate-300 bg-[#eaeef1] px-3 text-slate-700 transition-all duration-200 hover:bg-[#dde3e7] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary/50"
        >
          Administration
        </Button>
      ) : null}
    </>
  );
};
